module.exports = __webpack_public_path__ + "static/media/pdf.cdca5de9.png";